var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCount2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1118 6.3709C42.3382 4.05808 39.1363 2.3142 35.6887 1.23884C32.2412 0.163484 28.6156 -0.222307 25.019 0.103502C21.4224 0.429306 17.9251 1.46033 14.727 3.13771C11.5288 4.81508 8.69233 7.10596 6.37952 9.87954C4.0667 12.6531 2.32283 15.8551 1.24747 19.3026C0.172104 22.7501 -0.213686 26.3757 0.112122 29.9723C0.43793 33.569 1.46896 37.0662 3.14633 40.2644C4.82371 43.4625 7.11458 46.299 9.88816 48.6118L27.5 27.4914L45.1118 6.3709Z",
    fill: "#1AA5BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCount2);
export default __webpack_public_path__ + "static/media/count2.7f4537f919070be0b1de4ca170cb54ee.svg";
export { ForwardRef as ReactComponent };